export const RETRY_PERIOD_BY_RETRY_COUNT = {
  0: 0,
  1: 2000,
  2: 10_000,
  3: 30_000,
};

// Returned by the auto-reconnect policy once the backoff table is exhausted.
// SignalR treats a `null` return value from `nextRetryDelayInMilliseconds` as
// "give up forever" — that left the hub permanently Disconnected after ~42s
// of downtime (e.g. a laptop sleep), so we keep retrying at a steady cadence.
export const RECONNECT_FALLBACK_DELAY_MS = 60_000;
